export enum StatusEntity {
  Disabled,
  Enabled,
}

export enum TagStatus {
  WithoutTag,
  PendingAttachment,
  PendingApproval,
  Damaged,
  HasTag,
}

export enum HealthStatus {
  Unknown,
  Healthy,
  NeedsMaintenance,
  OutOfService,
}

export enum PlanStatus {
  Pending,
  Started,
  Paused,
  Closed,
}

export enum Operation {
  Input = 1,
  Output,
  Transmission,
}

export enum OperationType {
  Discovery = 1,
  Disposal,
  Missing,
  Location,
  Custodian,
  Both,
}